import {Link} from 'react-router';

import {statsRowT} from '@/lib/types/stats.types';

import {createDataTableConfig} from '@/lib/helpers/config';

import {useViewQuery} from '@/hooks';

import {StatsRowComponent} from '@/components';
import Page from '@/components/Page';
import {DataTable} from '@/components/dataTable';

// TODO: COME BACK AND UPDATE TO POSTION_ITEM
function SpeculatorItems() {
  const {data: stats} = useViewQuery({
    view: 'speculator_item_stats',
  });

  // Data Table
  const {table, title, columns, searchColumn, columnsDisplay} = createDataTableConfig({
    table: 'Item',
    title: 'Items Summary',
    searchColumn: 'item_sku',
    columns: [
      'item_sku',
      'item_inventory_type',
      ['Product', ['product_name', 'product_id']],
      ['Market', ['market_name', 'market_id']],
    ],
    columnsDisplay: [
      {
        field: 'item_sku',
        header: 'Item Sku',
      },
      {
        field: 'item_id',
        header: 'Item',
        render(row) {
          return (
            <Link
              className="text-primary hover:text-primary dark:text-primary"
              to={`/products/${row.Product.product_id}`}
            >
              {row.Product.product_name}
            </Link>
          );
        },
      },
      {
        field: 'item_inventory_type',
        header: 'Item Type',
      },
      {
        field: 'fk_market_id',
        header: 'Market',
        render(row) {
          return (
            <Link className="text-primary hover:text-primary dark:text-primary" to={`/markets/${row.Market.market_id}`}>
              {row.Market.market_name}
            </Link>
          );
        },
      },
    ],
  });

  // Stats
  const statsRow: statsRowT = [
    {
      title: 'Total Products',
      value: stats?.total,
      subtitle: 'This Month',
      icon: 'ri-stack-line',
      color: 'primary',
      change: 1.03,
      cardClass: 'Stats-main-card primary',
    },
    {
      title: 'Total Active Products',
      value: stats?.active,
      subtitle: 'This Month',
      icon: 'ri-money-dollar-circle-line',
      color: 'warning',
      change: -1.28,
      cardClass: 'Stats-main-card warning',
    },
    {
      title: 'Total Inactive Products',
      value: stats?.inactive,
      subtitle: 'This Month',
      icon: 'ri-money-dollar-box-line',
      color: 'secondary',
      change: -1.28,
      cardClass: 'Stats-main-card secondary',
    },
  ];

  return (
    <Page currentPage="Item">
      <StatsRowComponent stats={statsRow} />
      <DataTable
        table={table}
        title={title}
        columns={columns}
        columnsDisplay={columnsDisplay}
        searchColumn={searchColumn}
        hideAdd
      />
    </Page>
  );
}

export default SpeculatorItems;
